module.exports = __webpack_public_path__ + "static/media/icon.8ccb1666.png";